import http from './index';

export const getCurrentUser = async () => http.get('/users/current');

export const setCurrentUserLang = async (values) => http.patch('/users/current', values);
